export default defineNuxtPlugin(async (nuxtApp) => {
    const config = useRuntimeConfig()
    const KEY = 'amosweb.public-config'

    if (true) {
        const cached = localStorage.getItem(KEY)
        if (cached) Object.assign(config.public, JSON.parse(cached))
    }

    try {
        // Same origin/interceptors as every other API call in the app. The build id keys the browser cache
        // (max_age=300): a manifest cached under the previous release lacks the routes of this one.
        const buildId = config.app.buildId
        const {data} = await nuxtApp.$axios.get('/api/public-config', {params: buildId ? {build: buildId} : {}})
        Object.assign(config.public, data)
        if (true) localStorage.setItem(KEY, JSON.stringify(data))
    } catch (e) {
        // Keep build-time + cached values, but do not fail silently while debugging.
        console.error('[public-config] fetch failed, using fallback keys:', e)
    }
})
